import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { PanelModule } from 'primeng/panel';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PanelModule, MessageModule, SharedModule],
})
export class VersionComponent {}
